import store from "../redux-store/index";

import {
  saveSaleLocally,
  loginOffline,
  filterRemoteStore,
  saleCloseOffline,
  fetchOfflineSale,
  fetchResourceOrdersOffline,
  splitSalePhysically,
  transferTableTicketOffline,
  transferItemsOffline,
  transferTicketOffline,
  saveSaleOffline,
  changeTicketStatusOffline,
  cancelTicketOffline,
  updateTicketPrintStatus,
  updateAllTicketsPrintStatus,
  getSaleTicketsToPrintOffline,
} from "helper/OfflineHelper";
import {
  cancelKOTSuccess,
  closeOrder,
  closeOrderSuccess,
  deleteItem,
  getTableOrdersData,
  getTableOrdersDataSuccess,
  splitItems,
  splitOrders,
  transferItem,
  transferItemSuccess,
  transferKOT,
  transferKOTSuccess,
  transferTable,
  transferTableSuccess,
  cancelKOT,
  splitOrdersSuccess,
  print,
  printSuccess,
  printKOTSuccess,
  printKOTSlice,
} from "redux-store/slices/TableViewSlice";
import { reopenOrder, saveSaleData } from "redux-store/slices/SaleSlice";
import { getLoginRespoonse, switchUser } from "redux-store/slices/LoginSlice";
import { fetchHoldOrder, getOpenOrderData, getOpenOrderDataSuccess, saveMyorder, updateOrderStatus, getSearchOrders, getSearchOrdersSuccess } from "redux-store/slices/MyOrderSlice";
import { convertArrayToObject, deleteErrorsField } from "helper/commonHelpers";
import { fetchOrderData } from "redux-store/slices/MyOrderSlice";
import { handleSaveSaleData, updatePaymentClose, updatePaymentSuccess, updatePaymentToServer, updatePaymnetFailure } from "redux-store/slices/CheckoutSlice";
import { printSale, printSaleTickets } from "helper/printHelper";
import { getUnprintedTickets } from "redux-store/slices/PrinterSlice";
import { ToastNotifyError, ToastNotifySuccess } from "commonComponents/ToastNotify";
import { isMasterOffline, isSlave } from "helper/localServer";
import { ORDER_CLOSED, REST_SALE_ITEMS_ON_HOLD } from "utils/constants";
import { updateAdhocTables } from "helper/adhocTableHelpers";
import { arrayToMap, getChannelData } from "helper/catalogueHelpers";

// Moved to @rista/core/facade/ServiceFacade. isOffline is IMPORTED as well as re-exported
// because this file calls it 38 times in its own body, and an `export ... from` re-export
// creates no local binding (hazard 30). isSyncStarted is re-exported only — nothing here calls
// it. othersDataTypes is no longer imported at all: the only body that iterated it,
// getCatalogueDataFn, moved to core with the other seven fetchers, so its re-export at the
// bottom of this file is now a plain `export ... from` again.
import { isOffline, isSyncStarted } from "@rista/core/facade/ServiceFacade";
export { isOffline, isSyncStarted };

// ── Moved to @rista/core/facade/ServiceFacade ──────────────────────────────────────────────────
// The eight catalogue/resource fetchers below now live in core. RE-EXPORTED ONLY, with no
// matching import: this file's own body does not call any of them (checked per name), so
// hazard 30's "a re-export creates no local binding" trap does not apply here.
//
// Seven of them are in core's `index.desktop.ts` — they take this app's loader-suppression flag
// and fire its `*CallComplete` actions, neither of which the other platform has.
// `getCatalogueDataFn` is in core's `shared.ts`: THIS app's implementation is now BOTH
// platforms', which repairs a long-standing ReferenceError on the other side. Behaviour here is
// unchanged. See that file's docstring.
export {
	getItemsFn,
	getOptionSetsFn,
	getCatalogueDataFn,
	getDiscountsFn,
	getResourceFn,
	getResourceGroupsFn,
	getCategoryDataFn,
	getMenuDataFn,
} from "@rista/core/facade/ServiceFacade";

// ── Moved to @rista/core/facade/ServiceFacade ──────────────────────────────────────────────────
// The last three of the eighteen catalogue/resource/printer fetchers. RE-EXPORTED ONLY: this
// file's own body calls none of them (checked per name), so hazard 30 does not apply.
//
// `getPrinterDataFn` is in core's `shared.ts` — it was byte-identical on both platforms, the one
// fetcher of the eighteen that needed no variant. The other two are in `index.desktop.ts`,
// because their offline branches fire a `*CallComplete` action the other platform's slices do
// not define.
export {
	getAllTablesFn,
	getPrinterDataFn,
	getPrintersFn,
} from "@rista/core/facade/ServiceFacade";

export function saleCheckoutSave(ip) {
	function callOffline() {
		saveSaleOffline({
			sale: ip.postBody,
			callback: (res) => {
				if (res) {
					store.dispatch(updatePaymentSuccess(res));
				} else {
					store.dispatch(updatePaymnetFailure(res));
				}
				ip.callback(res)
			}
		});
	}
	if (isOffline()) {
		callOffline();
		return;
	}
	store.dispatch(handleSaveSaleData(ip));
}


export function deleteItemFn(ip) {
	function callOffline() {
		saveSaleOffline({
			sale: ip.dataToSend,
			callback: ip.callback,
		});
	}
	if (isOffline()) {
		callOffline();
		return;
	}
	store.dispatch(deleteItem(ip));
}

// Moved to @rista/core/facade/ServiceFacade (2026-09-15, my-orders v2). Re-export only.
export { myOrderSaveSaleFn } from "@rista/core/facade/ServiceFacade";

export function performLogin(ip) {
	if (isOffline()) {
		loginOffline(ip);
		return;
	}
	store.dispatch(getLoginRespoonse(ip));
}

export function switchUserFn(ip) {
	if (isOffline() || ip.loginOffline) {
		loginOffline(ip, true);
		return;
	}
	store.dispatch(switchUser(ip));
}

// Moved to @rista/core/facade/ServiceFacade — shared.ts owns it, the two apps' bodies were
// token-identical. Re-export only; this file's own body does not call it (ledger rule 5).
export { performLogout } from "@rista/core/facade/ServiceFacade";

// Moved to @rista/core/facade/ServiceFacade (2026-09-29, My Orders v2's shared customer lookup). Re-export only.
export { customerSearch } from "@rista/core/facade/ServiceFacade";

// Moved to @rista/core/facade/ServiceFacade (2026-09-15, my-orders v2). Re-export only.
export { getOpenOrderFn } from "@rista/core/facade/ServiceFacade";

export function getHoldOrdersFn(ip) {
	function callOffline() {
		filterRemoteStore({
			filter: { "data": ip.dataToSend },
			cb: ip.callback
		});
	}
	if (isOffline()) {
		callOffline();
		return;
	}
	store.dispatch(fetchHoldOrder(ip));
}

// Moved to @rista/core/facade/ServiceFacade (2026-09-17, my-orders v2 search). Re-export only.
export { getMyOrderSearchFn } from "@rista/core/facade/ServiceFacade";

export function closeSaleFn(ip) {
	function callOffline() {
		const sale = deleteErrorsField(ip.postBody);
		saleCloseOffline({
			sale: ip.sale || ip.postBody,
			callback: ip.callback,
		});
	}
	if (isOffline()) {
		callOffline();
		return;
	}
	store.dispatch(updatePaymentToServer(ip));
}

// Moved to @rista/core/facade/ServiceFacade (2026-09-15, my-orders v2 detail). Re-export only.
export { closeOrderFm } from "@rista/core/facade/ServiceFacade";

export { fetchMyOrderDataFn } from "@rista/core/facade/ServiceFacade";

export function fetchTableOrderDataFn(resourceId) {
	if (!resourceId) return;
	function callOffline() {
		fetchResourceOrdersOffline({
			resourceId,
			cb: (sale) => {
				console.log("============ticketGroup INSIDE fetchResourceOrdersOffline", sale);
				store.dispatch(getTableOrdersDataSuccess(sale))
				store.dispatch(saveSaleData(sale[0]));
			}
		});
	}
	if (isOffline()) {
		callOffline();
		return;
	}
	store.dispatch(getTableOrdersData(resourceId));
}


export function updatePaymentFn(ip) {
	function callOffline() {
		saleCloseOffline({
			sale: ip.postBody,
			callback: (response) => {
				if (response) {
					store.dispatch(updatePaymentSuccess(response));
					printSaleTickets(response, response?.tickets)
					printSale(response, store.getState().printerStore?.defaultPrinter || {})
				} else {
					store.dispatch(updatePaymnetFailure(response));
				}
				if (ip.callback) {
					ip.callback(response);
				}
			}
		});
	}
	if (isOffline()) {
		callOffline();
		return;
	}
	store.dispatch(updatePaymentClose(ip));
}

// Moved to @rista/core/facade/ServiceFacade — the two apps' bodies were byte-identical.
// Re-exported so this file's importers are unchanged; not used inside this file.
export { updateFulfillmentStatementFn } from "@rista/core/facade/ServiceFacade";

export function splitOrderFn(ip) {
	function callOffline() {
		splitSalePhysically({
			sale: ip.sale,
			callback: (res) => {
				fetchTableOrderDataFn(ip.resourceId);
				// store.dispatch(splitOrdersSuccess(res));
			}
		});
	}
	if (isOffline()) {
		callOffline();
		return;
	}
	store.dispatch(splitOrders({ sale: ip.sale }));
}

export function splitItemsFn(ip) {
	function callOffline() {
		saveSaleOffline({
			sale: ip.dataToSend,
			callback: ip.callback,
		});
	}
	if (isOffline()) {
		callOffline();
		return;
	}
	store.dispatch(splitItems(ip))
}

export function transferTableFn(ip) {
	let { dataToSend, callback } = ip;
	function callOffline() {
		transferTableTicketOffline({
			...dataToSend,
			callback,
			cb: (res) => {
				store.dispatch(transferTableSuccess(res));
				printSaleTickets(res, res?.tickets)
			}
		})
	}
	if (isOffline()) {
		callOffline();
		return;
	}
	store.dispatch(transferTable(ip));
}

export function transferItemFn(ip) {
	function callOffline() {
		transferItemsOffline({
			...ip,
			cb: (res) => {
				store.dispatch(transferItemSuccess(res));
				printSaleTickets(res?.toSale, res?.toSale?.tickets)
			}
		});
	}
	if (isOffline()) {
		callOffline();
		return;
	}
	store.dispatch(transferItem(ip));
}

export function transferKOTFn(ip) {
	function callOffline() {
		transferTicketOffline({
			...ip,
			cb: (res) => {
				store.dispatch(transferKOTSuccess(res));
				ip.callback && ip.callback(res);
				printSaleTickets(res?.toSale, res?.toSale?.tickets)
			}
		});
	}
	if (isOffline()) {
		callOffline();
		return;
	}
	store.dispatch(transferKOT(ip));
}

export function changeTicketStatusFn(ip) {
	function callOffline() {
		changeTicketStatusOffline({
			...ip,
			cb: (res) => {
				store.dispatch(cancelKOTSuccess(res));
				printSaleTickets(res, res?.tickets)
			},
			status: "Cancelled"
		})
	}
	if (isOffline()) {
		callOffline();
		return;
	}
	store.dispatch(cancelKOT(ip));
}

export function cancelTicketFn(ip) {
	function callOffline() {
		cancelTicketOffline({
			...ip,
			cb: (res) => {
				store.dispatch(cancelKOTSuccess(res));
				printSaleTickets(res, res?.tickets)
			},
			status: "Cancelled"
		})
	}
	ip["callback"] = (res) => {
		printSaleTickets(res, res?.tickets);
	}
	if (isOffline()) {
		callOffline();
		return;
	}
	store.dispatch(cancelKOT(ip));
}

export function printBillFn(order) {
	function callOffline() {
		let cloneOrder = structuredClone(order);
		cloneOrder["opType"] = 'Print';
		saveSaleOffline({
			sale: cloneOrder,
			callback: (res) => {
				store.dispatch(printSuccess(res));
			},
		});
	}
	if (isOffline()) {
		callOffline();
		return;
	}
	store.dispatch(print(order))
}

export function updateTicketPrintStatusFn(ip) {
  function callOffline() {
    updateTicketPrintStatus({
      ...ip,
      cb: (res) => {
				updateAdhocTables(res);
        store.dispatch(printKOTSuccess(res));
        if (ip.callback) {
          ip.callback(res);
        }
      },
    });
  }
  if (isOffline()) {
    callOffline();
    return;
  }
  store.dispatch(printKOTSlice(ip));
}

export function updateAllTicketsPrintStatusFn(ip) {
  function callOffline() {
    updateAllTicketsPrintStatus({
      ...ip,
      cb: (res, err) => {
				if (!res?.code && !err) {
					store.dispatch(printKOTSuccess(res));
				}
				ip.callback?.(res, err);
      },
    });
  }
  if (isOffline()) {
    callOffline();
    return;
  }
  store.dispatch(printKOTSlice(ip));
}

// Moved to @rista/core/facade/ServiceFacade (2026-09-15, my-orders v2 detail). Re-export only.
export { printBillFunction } from "@rista/core/facade/ServiceFacade";

export function getUnprintedTicketsFn(ip) {
	
  const errorCallback = (error) => {
    if (ip.errorCallback) ip.errorCallback(error);
  };
  function callOffline() {
	// getSaleTicketsToPrintOffline returns a flat array of sale objects,
    // but onUnprintedSalesSuccess expects { ticketSales: [], itemLabelSales: [] }.
    // Normalize the response to match the online API shape.
    const cb = (res) => {
      ip.callback({ ticketSales: res, itemLabelSales: [] });
    };
    getSaleTicketsToPrintOffline(cb, errorCallback);
  }

  if (!ip.dataToSend) ip.dataToSend = {};
   if (!ip.dataToSend.printPath) {
    const now = new Date();
    const t1 = now.toLocaleTimeString("en-GB", { hour12: false });
    const t2 = new Date(now.getTime() + 10000).toLocaleTimeString("en-GB", { hour12: false });

    ip.dataToSend.printPath =
      `onUnprintedSaleObjSuccess(STEP-3)-else*[${t1}] ->==>delayedSaleTicketTask(STEP-2)[${t2}] ->`;
  }

  if (isOffline()) {
    callOffline();
    return;
  }

  const callback = (res) =>
    res.code ? ip.errorCallback(res) : ip.callback(res);

  store.dispatch(
    getUnprintedTickets({
      dataToSend: ip.dataToSend,
      ticketsToggle: ip.ticketsToggle,
      labelsToggle: ip.labelsToggle,
      callback,
      errorCallback,
    })
  );
}

/**
 * Updates discount data.
 * 
 * @param {Object} payload - The payload containing data and callback.
 * @param {Object} payload.data - saleData to be updateed
 * @param {Function} payload.callback - The callback function to be executed after updating the discount data.
 * @returns {Object} saleData
 */
// Moved to @rista/core/facade/ServiceFacade (shared.ts — the two bodies were
// token-identical). Re-export only: nothing in this file calls it.
export { updateDiscountFn } from "@rista/core/facade/ServiceFacade";

export function reopenOrderFn(ip) {
  if (isOffline()) {
	// TODO
    // not supported in offline mode by rista-library
    return;
  }
  store.dispatch(reopenOrder(ip));
}

// Moved to @rista/core/facade/ServiceFacade — re-exported so importers are unchanged. The one
// importer is redux-store/saga/pos/catalog.js, which iterates the table after a catalogue
// response to write each section into the offline store.
//
// ⚠️ For a while this had to be an IMPORT plus a local `export { othersDataTypes }`, because a
// re-export creates no local binding (hazard 30) and this file iterated the table itself in
// getCatalogueDataFn — the earlier `export ... from` form threw `ReferenceError` at runtime.
// That body has now moved to core, so nothing here references the name and the plain re-export
// is correct again. Restore the import form if any body in this file starts using it.
export { othersDataTypes } from "@rista/core/facade/ServiceFacade";

// Moved to @rista/core/facade/ServiceFacade (shared.ts — all three token-identical in both
// apps). Re-export only: nothing in this file calls them.
export { saveSaleFn, cancelOrderFn, voidOrderFn } from "@rista/core/facade/ServiceFacade";

